<template>
  <!-- Reminder Block -->
  <div class="row no-gutters justify-content-center bg-primary-dark-op">
    <div class="hero-static col-sm-8 col-md-6 col-xl-4 d-flex align-items-center p-2 px-sm-0">
      <div class="block block-transparent block-rounded w-100 mb-0 overflow-hidden">
    <div class="block-content block-content-full px-lg-5 px-xl-6 py-4 py-md-5 py-lg-6 bg-white">
      <!-- Header -->
      <div class="mb-2 text-center">
        <router-link :to="{ name: 'welcome' }" class="link-fx font-w700 font-size-h1" href="index.html">
          <span class="text-dark">{{$t('auth.verifyEmail.' + selectedChain)}}</span><span class="text-primary"> {{$t('auth.verifyEmail.detective')}}</span>
        </router-link>
        <p class="text-uppercase font-w700 font-size-sm text-muted">{{$t('auth.verifyEmail.verifyYourEmail')}}</p>
        <p v-text="currentUser.userEmail" class="font-size-lg font-w700"></p>
      </div>
      <!-- END Header -->
      <div class="row">
        <div class="col-md-12 text-center">
          <div v-show="success" class="alert alert-success alert-dismissable" role="alert">
            <button @click="success = ''" type="button" class="close" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <p v-text="success" class="mb-0"></p>
          </div>
          <div v-show="error" class="alert alert-danger alert-dismissable" role="alert">
            <button @click="error = ''" type="button" class="close" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <p v-text="error" class="mb-0"></p>
          </div>
          <button @click="resendEmail" type="button" class="btn btn-hero-primary mt-2" :disabled="loading">
            <font-awesome-icon v-if="!loading" icon="envelope" fixed-width class="mr-1"/><font-awesome-icon v-else icon="spinner" fixed-width class="mr-1 fa-spin"/> {{$t('auth.verifyEmail.sendEmailAgain')}}
          </button>
        </div>
        <div class="col-md-12 text-center mt-2">
          <a @click="logout" href="javascript:void(0)" class="mt-2">{{$t('auth.verifyEmail.logout')}}</a>
        </div>
      </div>
    </div>
  </div>
    </div>
  </div>
  <!-- END Reminder Block -->
</template>

<script>
import VueTimers from 'vue-timers/mixin'
const fb = require('@/firebaseConfig.js')

export default {
  name: 'verifyemail',
  mixins: [VueTimers],
  timers: {
    checkAuthState: { time: 2000, autostart: true, repeat: true }
  },
  computed: {
    selectedLanguage () {
      return this.$store.state.options.selectedLanguage
    },
    selectedChain () {
      return this.$store.state.options.selectedChain
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    isEmailVerified () {
      return this.currentUser.emailVerified
    }
  },
  data () {
    return {
      loading: false,
      success: '',
      error: ''
    }
  },
  methods: {
    resendEmail: function () {
      this.loading = true
      fb.auth.currentUser.sendEmailVerification()
        .then(() => {
          this.success = this.$t('auth.verifyEmail.emailSuccessfullySent')
          this.loading = false
        })
        .catch((error) => {
          this.error = error.message
          this.loading = false
        })
    },
    checkAuthState () {
      fb.auth.currentUser.reload()
        .then(() => { this.$store.dispatch('setCurrentUser', fb.auth.currentUser) })
    },
    logout: function () {
      fb.auth.signOut().then(() => {
        this.$router.replace('/' + this.selectedLanguage + '/' + this.selectedChain)
      })
      this.$store.commit('resetUser')
    }
  },
  watch: {
    isEmailVerified: function () {
      this.$router.replace('/' + this.selectedLanguage + '/' + this.selectedChain + '/dashboard')
    }
  }
}
</script>

<style scoped>

</style>
